function dropdownShow(button: string, container: string, overlay: string, transparent: boolean) {
  let element1 = document.getElementById(button)
  let element2 = document.getElementById(container)
  let element3 = document.getElementById(overlay)

  element1?.classList.add('active')
  element2?.classList.add('show')
  element3?.classList.add(transparent ? 'menu-overlay-transparent' : 'menu-overlay')
}

function dropdownHide(button: string, container: string, overlay: string, transparent: boolean) {
  let element1 = document.getElementById(button)
  let element2 = document.getElementById(container)
  let element3 = document.getElementById(overlay)

  element1?.classList.remove('active')
  element2?.classList.remove('show')
  element3?.classList.remove(transparent ? 'menu-overlay-transparent' : 'menu-overlay')
}

export { dropdownShow, dropdownHide }
